import { ComplexTable } from '@synergy/table';
import { Col, Row } from "antd";
import i18next from "i18next";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "../../contexts/AuthContext";
import query from '../../server/constants.api';
import logger from "../../server/server";
import useFetch from "../../server/useFetch";
import { PageContent, PageSection, PageTitle } from "../../styles/global/Pages.styled";
import { Text } from "../Global/Atomics/Text";

export const Register = () => {
    const { t } = useTranslation(); // Translation hook
    const { user, tenant } = useAuthContext();
    logger.info('User ' + user + ' accessed  Register page! Tenant: ' + tenant);

    const {
        data: registryData,
        isFetching: registryIsFetching,
        refetch: refetchRegistryData,
        isError: registryIsError,
    } = useFetch('/items', 'getRegistryData', {
        tenant: "NOVA - Campus de Campolide",
    }, null, null, query.middlewareURL); // Custom hook for fetching complex table data

    const customInput = {
        placeholder: t('search'),
    }

    // Effect to refetch table data when language changes
    useEffect(() => {
        try {
            refetchRegistryData();
        } catch (error) {
            // logger.error('Error in useEffect refetchTableComplex');//LOG
            console.error('(Register page) Error in useEffect refetchTableComplex:', error);
            //reportError(error); // Send error report to backend
            logger.error('(Register page) User: ' + user['cognito:username'] + ' Tenant: ' + tenant + ', Error in useEffect refetchTableComplex:', error);
        }
    }, [i18next.resolvedLanguage])

    useEffect(() => {
        if (registryIsError) {
            // logger.error('Error in useEffect if exists data setFetchData');//LOG
            console.error('(Register page) Error in useEffect if exists data setFetchData:', registryIsError);
            //reportError(error); // Send error report to backend
            logger.error('(Register page)  User: ' + user + ' Tenant: ' + tenant + ', Error in useEffect if exists data setFetchData:', registryIsError);
        }
    }, [registryIsError])

    return (
        <PageContent id='registerTable'>
            <PageSection $padding='32px 0 32px 32px'>
                <Row gutter={[32, 32]} style={{ width: '99%' }}>
                    <Col span={24}>
                        <PageTitle>
                            <div className="title">
                                <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight='regular' $marginRight='s03'>
                                    {t('Assets')} </Text>
                            </div>
                        </PageTitle>
                    </Col>
                    <Col span={24}>
                        <ComplexTable fetchData={registryData?.map(x => { return { ...x, class: t(x.class), layer: t(x.layer) } })} hrefLink='/registry/item/${id}' customInput={customInput}
                            pagination={{ showSizeChanger: true, defaultPageSize: 8, pageSizeOptions: [8, 10, 20, 30, 40] }}
                            language={i18next.resolvedLanguage} isLoading={registryIsFetching} tableConfiguration={tableConfig} />
                    </Col>
                </Row>
            </PageSection>
        </PageContent >
    )
};

const tableConfig = {
    collumnsConfiguration: [
        {
            "title": "Nome",
            "dataIndex": "name",
            "filterMultipleSelect": false
        },
        {
            "title": "Layer",
            "dataIndex": "layer",
            "filterMultipleSelect": false
        },
        {
            "title": "Tipologia",
            "dataIndex": "class",
            "filterMultipleSelect": false
        }
    ],
    hideSelectAll: false
};